<template>
    <div v-if="is_active_tab" :class="[action_visibility ? '' : 'hidden', 'ibox-tools actions row m-b-xs']">
        <div class="col-md-12">
            <div class="pull-right">
                <v-btn v-if="current_selection_filter !== null && current_selection_filter.length > 0
                && current_selection_filter !== '-1'
                && (authSuperadmin === '1' || ownFilter.indexOf(current_selection_filter) > -1)"
                        type="button"
                        class="btn btn-secondary m-r-sm"
                        @click.stop.prevent="editDeleteFilterModal">
                    <i class="fa-regular fa-pencil m-r-xs"></i>
                    {{ t_edit_delete_filter }}
                </v-btn>
                <v-btn type="button"
                        class="btn btn-w-m btn-secondary"
                        @click.stop.prevent="newFilterModal">
                    <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                    {{ t_new_filter }}
                </v-btn>
                <v-btn v-if="current_selection_column_preset !== null && current_selection_column_preset !== '-1'"
                        type="button"
                        class="btn btn-secondary m-l-sm"
                        @click.stop.prevent="downloadMode('csv')">
                    {{ t_download_csv }}
                </v-btn>
                <v-btn v-if="current_selection_column_preset !== null && current_selection_column_preset !== '-1'"
                        type="button"
                        class="btn btn-secondary m-l-sm"
                        @click.stop.prevent="downloadMode('xls')">
                    {{ t_download_xls }}
                </v-btn>
            </div>
            <div class="col-md-2 pull-right no-padding m-r-sm">
                <select :data-placeholder="t_select_filter"
                        class="chosen-select filter"
                        name="existing_filter"
                        :title="t_select_filter">
                    <option v-for="element in filter" :value="element.value">{{ element.label }}</option>
                </select>
            </div>
            <div class="pull-right">
                <v-btn type="button"
                       v-if="current_selection_column_preset !== null && current_selection_column_preset.length > 0
                       && current_selection_column_preset !== '-1' && authEdit === '1'"
                        class="btn btn-secondary m-r-sm"
                        @click.stop.prevent="editDeleteColumnPresetModal">
                    <i class="fa-regular fa-pencil m-r-xs"></i>
                    {{ t_edit_delete_column_preset }}
                </v-btn>
                <v-btn v-if="authEdit === '1'"
                       type="button"
                       class="btn btn-w-m btn-secondary m-r-sm"
                       @click.stop.prevent="newColumnPresetModal">
                    <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                    {{ t_new_column_preset }}
                </v-btn>
            </div>
            <div class="col-md-2 pull-right no-padding m-r-sm">
                <select :data-placeholder="t_select_column_preset"
                        class="chosen-select columns"
                        name="existing_columns"
                        :title="t_select_column_preset">
                    <option v-for="element in columns" :value="element.value">{{ element.label }}</option>
                </select>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'filter',
            'ownFilter',
            'columns',
            'authEdit',
            'authSuperadmin',
            'selectedFilter',
            'selectedColumn',
            'action_visibility'
        ],
        data() {
            return {
                t_edit_delete_filter: Lang.langGet("Edit / Delete Filter"),
                t_edit_delete_column_preset: Lang.langGet("Edit / Delete Column Preset"),
                t_new_filter: Lang.langGet("New Filter"),
                t_new_column_preset: Lang.langGet("New Column Preset"),
                t_select_filter: Lang.langGet("Select a filter..."),
                t_select_column_preset: Lang.langGet("Select a Column Preset..."),
                t_download_csv: Lang.langGet(".csv"),
                t_download_xls: Lang.langGet(".xls"),
                t_download_pdf: Lang.langGet(".pdf"),
                current_selection_filter: '',
                current_name_filter: '',
                current_selection_column_preset: '',
                current_name_column_preset: '',
                is_active_tab: false,
                downloading: false,
            }
        },
        watch: {
            filter: function (val, oldVal) {
                let changeVal = -1;
                let select = $('.system-reporting .ibox-heading .ibox-tools .chosen-select.filter');

                if (val.length < oldVal.length) {
                    let found = false;

                    val.forEach((element) => {
                        if (parseInt(element['value']) === parseInt(this.selectedFilter)) {
                            found = true;
                        }
                    });

                    if (found === true) {
                        changeVal = this.selectedFilter;
                    } else {
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                    }
                } else {
                    changeVal = this.selectedFilter;
                }

                this.$nextTick(function () {
                    select.val(changeVal).trigger("chosen:updated");
                    if (changeVal === -1) {
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                    } else {
                        this.current_selection_filter = changeVal;
                        this.current_name_filter = select.find('option:selected').text();
                    }
                    EaseEventBus.fire('loadedReportFilter');
                });

                EaseEventBus.fire('updateTable', {column: null, filter: changeVal});
            },
            columns: function (val, oldVal) {
                let changeVal = '';
                let select = $('.system-reporting .ibox-heading .ibox-tools .chosen-select.columns');

                if (val.length < oldVal.length) {
                    let found = false;

                    val.forEach((element) => {
                        if (parseInt(element['value']) === parseInt(this.selectedColumn)) {
                            found = true;
                        }
                    });

                    if (found === true) {
                        changeVal = this.selectedColumn;
                    } else {
                        this.current_selection_column_preset = '';
                        this.current_name_column_preset = '';
                    }
                } else {
                    changeVal = this.selectedColumn;
                }

                this.$nextTick(function () {
                    select.val(changeVal).trigger("chosen:updated");

                    if (changeVal === '-1') {
                        this.current_selection_column_preset = '';
                        this.current_name_column_preset = '';
                    } else {
                        this.current_selection_column_preset = changeVal;
                        this.current_name_column_preset = select.find('option:selected').text();
                    }
                    EaseEventBus.fire('loadedReportColumnPreset');
                });

                EaseEventBus.fire('updateTable', {column: changeVal, filter: null});
            }
        },
        methods: {
            editDeleteFilterModal: function () {
                EaseEventBus.fire('showEditDeleteFilterModal', {
                    name: this.current_name_filter,
                    id: this.current_selection_filter
                });
            },
            editDeleteColumnPresetModal: function () {
                EaseEventBus.fire('showEditDeleteColumnPresetModal', {
                    name: this.current_name_column_preset,
                    id: this.current_selection_column_preset
                });
            },
            newFilterModal: function () {
                EaseEventBus.fire('showNewFilterModal');
            },
            newColumnPresetModal: function () {
                EaseEventBus.fire('showNewColumnPresetModal');
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            },
            init: function () {
                this.$nextTick(() => {
                    let selectFilter = $('.system-reporting .ibox-heading .ibox-tools .chosen-select.filter');
                    let selectColumns = $('.system-reporting .ibox-heading .ibox-tools .chosen-select.columns');
                    selectColumns.val(this.selectedColumn).trigger("chosen:updated");
                    selectFilter.val(this.selectedFilter).trigger("chosen:updated");
                    this.current_selection_filter = selectFilter.val();
                    this.current_name_filter = selectFilter.find('option:selected').text();
                    this.current_selection_column_preset = selectColumns.val();
                    this.current_name_column_preset = selectColumns.find('option:selected').text();

                    selectFilter.chosen().change(() => {
                        this.current_selection_filter = selectFilter.val();
                        this.current_name_filter = selectFilter.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {column: selectColumns.val(), filter: selectFilter.val()});
                    });

                    selectColumns.chosen().change(() => {
                        this.current_selection_column_preset = selectColumns.val();
                        this.current_name_column_preset = selectColumns.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {column: selectColumns.val(), filter: selectFilter.val()});
                    });

                    if (!(selectFilter.val() === '-1' || selectFilter.val() === null) ||
                        !(selectColumns.val() === '-1' || selectColumns.val() === null)) {
                        this.$emit('update:action_visibility', true);
                        EaseEventBus.fire('FilterOrPresetWasSetReports');
                    }
                    EaseEventBus.listen('triggerUpdateTable', () => {
                        EaseEventBus.fire('updateTable', {column: this.current_selection_column_preset, filter: this.current_selection_filter});
                    });
                });
            },
            downloadMode: function (mode) {
                if(this.downloading === true) {
                    return;
                }

                this.downloading = true;
                EaseEventBus.fire('downloadMode', mode);
            }
        },
        mounted() {
            $(this.$el).appendTo('.system-reporting .ibox-heading');

            let $div = $("#reporting-list");
            let observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "class") {
                        let attributeValue = $(mutation.target).prop(mutation.attributeName);
                        this.is_active_tab = attributeValue.indexOf('active') !== -1;
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                        this.current_selection_column_preset = '';
                        this.current_name_column_preset = '';
                        this.init();
                    }
                });
            });
            observer.observe($div[0], {
                attributes: true
            });

            EaseEventBus.listen('downloadModeDone', () => {
               this.downloading = false;
            });

            EaseEventBus.listen('setNewReportFilterAsCurrent', (data) => {
                this.filter.forEach((element) => {
                    if (element.label === data.name) {
                        const selectFilter = $('.system-reporting .ibox-heading .ibox-tools .chosen-select.filter');
                        selectFilter.val(_.toString(element.value)).trigger("chosen:updated");
                        this.current_selection_filter = selectFilter.val();
                        this.current_name_filter = selectFilter.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {column: null, filter: selectFilter.val()});
                        axios.get('/cache/listreportingfilter/' + selectFilter.val());
                    }
                })
            })

            EaseEventBus.listen('setNewReportColumnPresetAsCurrent', (data) => {
                this.columns.forEach((element) => {
                    if (element.label === data.name) {
                        const selectColumns = $('.system-reporting .ibox-heading .ibox-tools .chosen-select.columns');
                        selectColumns.val(_.toString(element.value)).trigger("chosen:updated");
                        this.current_selection_column_preset = selectColumns.val();
                        this.current_name_column_preset = selectColumns.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {column: selectColumns.val(), filter: null});
                        axios.get('/cache/listreportingcolumn/' + selectColumns.val());
                    }
                })
            })
        }
    }
</script>
